const arquivo = () => import("./arquivo.vue");

const arquivoRoutes = {
  name: "arquivo",
  meta: {
    title: "ARQUIVO",
    requiresAuth: true,
  },
  component: arquivo,
};

export default arquivoRoutes;
